import React from 'react'
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { createKnowledgeDomain } from '../../services/school/knowledgedomains/knowledgeDomains';
import { useForm } from 'react-hook-form';
import { KnowledgeDomainType } from '../../types/KnowledgeDomain';
import { yupResolver } from '@hookform/resolvers/yup';
import toast from 'react-hot-toast';
import { routes } from '../../routes';
import { KnowledgeDomainFormValidation } from './KnowledgeDomainFormValidation';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import TextAreaFieldComponent from '../../components/inputs/TextAreafield/TextAreafieldComponent';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';

export const CreateKnowledgeDomain = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: createKnowledgeDomain, mutationKey: "createKnowledgeDomain" });
    const { control, handleSubmit, formState: { errors } } = useForm<KnowledgeDomainType>
    (
      {
      resolver: yupResolver(KnowledgeDomainFormValidation),
      defaultValues: {
        description: '', 
        status: true,
        code: '',
      },
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );

    const onSubmit = handleSubmit(async (data) => {
        try {
            const result = await mutation.mutateAsync(data);
            if (result) {
                toast.success("Dominio criado!");
                navigate(routes.knowledgeDomains);
            }
        } catch (err: any) {
            toast.error(`${mutation.error ?? err?.message}`);
        }
    });
  const handleBack = () => {
    navigate(routes.knowledgeDomains);
  }
    return (
        <form onSubmit={onSubmit} noValidate>
          <Card size='1'>
            <Flex direction='column' gap='4'>
              <TextAreaFieldComponent name="description" label="Nome" control={control} errors={errors} fieldProps={{ placeholder: 'Nome' }}  required={true}/>
              <TextFieldComponent name="code" label='Código' control={control} errors={errors} fieldProps={{ placeholder: 'Código' }} required={true}/>
              <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                <Button color='red' onClick={handleBack} disabled={mutation.isLoading}>
                  <ChevronLeftIcon /> voltar
                </Button>
                <Button type="submit" disabled={mutation.isLoading} variant='surface'  >
                  {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
                  Registar
                </Button>
              </Flex>
            </Flex>
          </Card>
        </form>
      );
}
